//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "xiaofeijilu",
  data() {
    return {
      isCard1: true,
      isCard2: false,
      showContent: [], //显示详细内容
      loading: false,
      title: 0,
      page: 1,
      quantity: 10,
      last_page: 0,
      content: [],
      scroller: [],
      membership_card_id: "",
      all_total_amount: 0,
      // 个人消费 会员卡消费 切换
      change_val:1,
    };
  },
  methods: {
    title_click: function (s) {
      this.scroller = [];
      this.page = 1;
      this.last_page = 0;
      this.membership_card_id = "";
      if (s == null) {
        this.isCard1 = true;
        this.isCard2 = false;
      } else {
        this.isCard1 = false;
        this.isCard2 = true;
        this.membership_card_id = s;
      }
      this.init();
    },
    onScrollBottom: async function () {
      if(this.page>this.last_page){
        return
      }
      if (this.loading === true) {
        return;
      } else {
        this.loading = true;
        if (this.membership_card_id == "") {
          let vip = ''
            if(this.change_val == 1){
              vip = ''
            }
            if(this.change_val == 2){
              vip = this.$route.query.id
            }
          await this.$HTTP
            .HttpPost("/Member/Order/getCarOrderList", {
              membership_card_id: vip,
              page: this.page + 1,
              quantity: this.quantity,
            })
            .then((data) => {
              this.page++;
              this.last_page = data.data.data.last_page;
              this.all_total_amount = data.data.data.all_total_amount;
              if (data.data.code === 200) {
                if (data.data.data.data.length != 0) {
                  this.content.push(...data.data.data.data);
                  for (const i in this.content) {
                    this.$set(this.showContent, i, false);
                  }
                }
                this.loading = false;
              }
            });
        } else {
          await this.$HTTP
            .HttpPost("/member/order/getSimpleCarOrderList", {
              membership_card_id: this.membership_card_id,
              page: this.page + 1,
              quantity: this.quantity,
            })
            .then((data) => {
              this.page++;
              this.last_page = data.data.data.last_page;
              this.all_total_amount = data.data.data.all_total_amount;
              if (data.data.code === 200) {
                if (data.data.data.data.length != 0) {
                  this.content.push(...data.data.data.data);
                  for (const i in this.content) {
                    this.$set(this.showContent, i, false);
                  }
                }

                this.loading = false;
              }
            });
        }
      }
    },
    init: function () {
      this.page = 1
      if (this.last_page === this.page) {
        // return;
      }
      if (this.membership_card_id == "") {
        let vip = ''
        if(this.change_val == 1){
          vip = ''
        }
        if(this.change_val == 2){
          vip = this.$route.query.id
        }
        this.$HTTP
          .HttpPost("/Member/Order/getCarOrderList", {
            membership_card_id: vip,
            page: this.page,
            quantity: this.quantity,
          })
          .then((data) => {
            this.last_page = data.data.data.last_page;
            this.all_total_amount = data.data.data.all_total_amount;
            if (data.data.code === 200) {
              this.content = data.data.data.data;
              for (const i in this.content) {
                this.$set(this.showContent, i, false);
              }
              setTimeout(() => {
                this.$vux.loading.hide()
              }, 200);
            }
          });
          
      } else {
        this.$HTTP
          .HttpPost("/member/order/getSimpleCarOrderList", {
            membership_card_id: this.membership_card_id,
            page: this.page,
            quantity: this.quantity,
          })
          .then((data) => {
            this.last_page = data.data.data.last_page;
            this.all_total_amount = data.data.data.all_total_amount;
            if (data.data.code === 200) {
              this.content = data.data.data.data;
              for (const i in this.content) {
                this.$set(this.showContent, i, false);
              }
            }
          });
      }
    },
    showDetail(item, idx) {
      if (this.showContent[idx]) {
        this.$set(this.showContent, idx, !this.showContent[idx]);
      } else {
        this.$set(this.showContent, idx, true);
      }
      if (this.membership_card_id == "") {
        this.$HTTP
          .HttpPost("/member/order/getOrderItem", {
            id: item.id,
          })
          .then((data) => {
            // this.xiaofeixiangmu_List = data.data.data;
            this.$set(this.content[idx],"xiaofeixiangmu_List",data.data.data)
            // this.xiaofeixiangmu_Arr[idx] = data.data.data
          });
      } else {
        this.$HTTP
          .HttpPost("/member/order/getSimpleOrderItem", {
            id: item.id,
          })
          .then((data) => {
            // this.$set(this.xiaofeixiangmu_Arr,idx,data.data.data)
            this.$set(this.content[idx],"xiaofeixiangmu_List",data.data.data)
          });
      }
    },
    change_btn(i){
      if(this.change_val != i){
        this.$vux.loading.show({
          text: 'Loading'
        })
        this.change_val = i;
        this.init();
      }else{
        return
      }
    }
  },
  mounted() {
    this.init();
  },
};



// WEBPACK FOOTER //
// ./src/components/xiaofeijilu.vue